import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {getBreadCrumbs} from '../../breadcrumbs'
import { useIntl } from 'react-intl'
import ListText from '../../../../components/ui/ListText'
import { useMutation, useQuery } from 'react-query'
import { getCampaignDetail, getRewards, putStatusCampaigns } from '../../../../modules/services/campaign.service'
import { toast } from 'react-toastify'


const CampaignDetailPage = () => {
  const {id} = useParams<{id: string}>()
  const navigate = useNavigate()

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  
  const {data:data, isLoading} = useQuery(['getDetailCampaign', id], async () => await getCampaignDetail(id) )
  const datas  = useQuery(['getRewards', data?.attributes.rewardsType], async () => await getRewards(data?.attributes.rewardsType) )
  
  const { mutateAsync, isLoading:loading } = useMutation(['changeStatus', id], putStatusCampaigns,{
    onSuccess: async () => {
      toast.success("Update Status Success")
      navigate('/loyalty-point/campaign')
    },
    onError(error : any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })

  return (
    <>
    {!isLoading  &&  <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Campaign Detail</p>
          </div>
        </div>
        <div className='separator mb-4'></div>
        <div className='card-body p-9'> 
            <div className='d-flex justify-content-between'>
              <div>
                <ListText head={"Campaign"} content={ data?.attributes.campaignName} />
                <ListText head={"Category"} content={data?.attributes.category} />
                <ListText head={"Benefit"} content={ typeof data?.attributes.rewardsType === "string" ? data?.attributes.rewardsType : datas.data?.attributes.name } />
                <ListText head={"Bonus Point"} content={"-"} />
                <ListText head={"Advice Setting"} content={`Start Date : ${data?.attributes.startDate} - End Date : ${data?.attributes.endDate}`} />
              </div>
              <div>
              {
                !loading ? <><button disabled={data?.attributes?.status === "finished" ? true : false}  className='btn btn-success' onClick={() => mutateAsync({"id" :id,"status":true})}>
                  Active
                </button> <button disabled={data?.attributes?.status === "finished" ? true : false} className='btn btn-danger' onClick={() => mutateAsync({"id" :id,"status":false})}>
                  Non Active
                </button> </>: <button
                 className='btn btn-success'
                 data-kt-indicator="on"
                 type="button"
               >
                 <span className="indicator-progress">Please wait... 
                 <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
              </button> 
              }
              </div>
            </div>
           
            <div className='separator mb-4'></div>
            { data!.attributes!.transactions.length > 0 &&
              <>
                <p className='fw-bold fs-6 p-0 mb-4'>Product</p>
                <div className='d-flex flex-wrap'>
                { data!.attributes!.transactions.map((e:any, i: any) =>(
                    <div className='border bg-light-warning border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3' key={i}>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{e.name}</div>
                    </div>
                  </div>
                ))}
                </div>
              </>
            }
           
            {
              data!.attributes!.rewards.length > 0 &&
              <>
                  <p className='fw-bold fs-6 p-0 mb-4'>Rewards</p>
                  <div className='d-flex flex-wrap'>
                  {data!.attributes!.rewards.map((e : any, i : any) =>(
                       <div className='border bg-light-primary border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3' key={i}>
                       <div className='d-flex align-items-center'>
                         <div className='fs-2 fw-bolder'>{e.name}</div>
                       </div>
                     </div>
                  ))}
                  </div>
              </>

            } 
        </div>

      </div> }
     
    </>
  )
}

const CampaignWrapper = () => {
    const intl = useIntl()
    return (
      <>
        <PageTitle breadcrumbs={getBreadCrumbs('loyalty-point/campaign')}>
          {intl.formatMessage({id: 'MENU.CAMPAIGN'})}
        </PageTitle>
        <CampaignDetailPage />
      </>
    )
  }
  
  export default CampaignWrapper